module.exports = __webpack_public_path__ + "img/1.1d6d15a9.png";